import { Action } from 'redux';

import { SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { Messages } from '~src/codegen/Localize';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { SpaceInfoItemTypeValue } from '~src/spacesPlatform/models/ContentType';
import { IGroupInfo } from '~src/userManagement/groups/models/IGroupInfo';

import { removeGroupsFromGroupSet } from '../actions/GroupSetMenuActions';
import { IGroupSetGroupInfo } from '../models/IGroupSetInfo';

export const RemoveGroupFromGroupSetAction: IEntityAction<IGroupInfo, {}> = {
    name: EntityActionNames.GroupRemoveFromGroupSet,
    translateName: (targetItems?: IGroupInfo[], state?: AppState) => {
        return Messages.removeGroupFromGroupSet_action();
    },
    isVisible: function(targetItems: IGroupInfo[], state: AppState, availableActions?: {}): boolean {
        if (state.spaceInfo.spaceType === SpaceInfoItemTypeValue.groupset) {
            return targetItems.length >= 1;
        }
        return false;
    },
    isClickable: function(availableActions: {}, targetItems: IGroupInfo[], state: AppState): boolean {
        return SessionUserSelectors.canManageUsers(state);
    },
    createReduxAction: function(targetItems: IGroupSetGroupInfo[]): Action {
        return removeGroupsFromGroupSet(targetItems);
    }
};